import script from "./EditPaymentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPaymentForm.vue?vue&type=script&setup=true&lang=js"

import "./EditPaymentForm.vue?vue&type=style&index=0&id=5677e8f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5677e8f8"]])

export default __exports__